/* eslint-disable no-nested-ternary */
import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';
import type { CardSize } from './types';

export const Wrapper = styled.div<{ size: CardSize; isModal: boolean }>`
  ${(props) =>
    props.isModal &&
    `
  max-height: 100vh;
  overflow: auto;
`}
  margin: 30px auto;
  width: min-content;
  max-width: 100%;
  position: relative;

  ${(props) =>
    props.size === 'fullscreen' &&
    `
    width: 100%;
    max-width: 1320px;
    height: 100%;
    padding: 50px;
  `}

  ${mediaQuery('tablet')} {
    padding: 0;
    width: 100%;
  }

  ${mediaQuery('small')} {
    // 0 to 600
    width: 100%;
    ${(props) =>
      props.isModal &&
      `
      padding: 0;
      height: 100%;
      margin: 0px;
      padding-left: 0px;
      padding-right: 0px;
    `}
  }
`;

export const Container = styled.div<{
  size: CardSize;
  noPadding: boolean;
  isModal: boolean;
}>`
  z-index: 1;
  position: relative;
  border-radius: 15px;
  background: ${(props) => props.theme.color.light.default};
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.15);
  padding: ${(props) => (props.noPadding ? 0 : '30px')};
  margin: auto;

  max-width: 100%;
  width: ${(props) => (props.size === 'large' ? 1140 : props.size === 'medium' ? 960 : 540)}px;

  ${mediaQuery('desktop')} {
    // 1000 to 1280
    width: ${(props) => (props.size === 'large' ? 960 : props.size === 'medium' ? 720 : 540)}px;
  }

  ${mediaQuery('medium')} {
    // 800 to to 1000
    width: ${(props) => (props.size === 'large' ? 720 : props.size === 'medium' ? 640 : 540)}px;
  }

  ${mediaQuery('tablet')} {
    // 600 to 800
    width: ${(props) => (props.size === 'small' ? '440px' : '100%')};
  }

  ${(props) =>
    props.size === 'fullscreen' &&
    `
    width: auto !important;
    height: 100%;
  `}

  ${mediaQuery('small')} {
    // 0 to 600
    margin: 0 24px;
    width: auto;
    padding: ${(props) => (props.noPadding ? 0 : '14px')};

    ${(props) =>
      props.isModal &&
      `

      height: 100%;
      width: 100%;
      margin: 0;
      border-radius: 0px;
      overflow: auto;
    `}
  }
`;
